<!-- Zweck: Stellt die HTML-Struktur für app dialogs customer survey component im Frontend bereit. -->
<div class="surveybox" [class.mobile]="msvc.isMobile()|async">
  <h1 mat-dialog-title>
    {{survey.title}}
  </h1>
  <div [innerHTML]="survey.message|raw" mat-dialog-content
  style="border-top: 1px solid lightgrey; border-bottom: 1px solid lightgrey; padding: 10px; min-width: 200px; min-height: 100px"></div>

  @if (survey.type == 'rating') {
    <div style="text-align: center">
      @for (r of ratings; track r) {
        <div class="starbox" (click)="setRating(r)" (mouseenter)="hoverStartStar(r)"
          (mouseleave)="hoverEndStar()" matTooltip="{{r}} / {{survey.max_rating}}">
          @if ((!hovering && current_rating < r) || (hovering && current_hover_rating < r)) {
            <svg-icon>favorit</svg-icon>
          }
          @if ((!hovering && current_rating >= r) || (hovering && current_hover_rating >= r)) {
            <svg-icon>favorit-voll</svg-icon>
          }
        </div>
      }
      <div style="text-align: center">
        Ihre Wertung: {{current_rating}} / {{survey.max_rating}}
      </div>
    </div>
  }

  @if (survey.type == 'question') {
    <div>
      @for (a of survey.answers; track a; let idx = $index) {
        <div>
          <mat-checkbox [(ngModel)]="answers[idx]" (change)="change_answer(idx)">{{a}}</mat-checkbox>
        </div>
      }
    </div>
  }

  @if (survey.comment_allowed) {
    <div>
      <hr>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Kommentar</mat-label>
          <textarea matInput [(ngModel)]="answer.comment"></textarea>
          <mat-hint>Hier können Sie uns noch eine Nachricht hinterlassen.</mat-hint>
        </mat-form-field>
      </div>
    }
    <div align="center" mat-dialog-actions>
      <button mat-raised-button (click)="send()" [disabled]="!valid">
        <svg-icon>senden</svg-icon> Senden
      </button>
    </div>
  </div>
